import MultiEmailInput from "Common/MultiEmailInput/MultiEmailInput";
import React, { useState } from "react";
import { LuMail, LuX } from "react-icons/lu";
import ChatIcon from "SVGS/ChatIcon";
import FormatMomentDate from "Utils/FormatMomentDate";
import NumberConversion from "Utils/NumberConversion";
import Validator, {
  ValidationTypes as V_Type,
} from "react-form-supervalidator";
import { isNullValidator } from "Utils/validators";
import { ErrorHandlingMessage } from "Utils/ErrorHandlingMessage";
import api from "http";
import { toast } from "react-toastify";
import MaskPhoneNumber from "Utils/MaskPhoneNumber";
import ReactPortal from "Components/ReactPortal/ReactPortal";
import CustomButtonNew from "Common/CustomButtonNew/CustomButtonNew";
import CustomInput from "Common/CustomInput/CustomInput";
const SendReceiptPopup = ({
  onClose,
  paymentMainId,
  paidAmount,
  receivedDate,
  patientInfo,
  isCashOrCheck = false,
}) => {
  const { email, phone } = patientInfo ?? { email: "", phone: "" };
  const [receiptMethod, setReceiptMethod] = useState("Email");
  const [emails, setEmails] = useState(email ? [email] : []);
  const [phoneNumber, setPhoneNumber] = useState(phone ?? "");
  const [myValidationModel, setMyValidationModel] = useState({
    emailToError: null,
    phoneNumberError: null,
  });
  const [loader, setLoader] = useState(false);

  const setValidation = () => {
    let myValidationObj = {
      ...myValidationModel,
      emailToError:
        receiptMethod === "Email"
          ? Validator(emails, [isNullValidator], ["Email is required"])
          : null,
      phoneNumberError:
        receiptMethod === "Text"
          ? Validator(
              phoneNumber,
              [V_Type.required],
              ["Phone number is required"],
            )
          : null,
    };
    setMyValidationModel(myValidationObj);
    return Validator(myValidationObj, V_Type.NullCheck);
  };
  const handleSendReceipt = async () => {
    let myValidation = setValidation();
    if (!myValidation) {
      setLoader(true);
      const payload = {
        paymentMainId,
        emailTo: receiptMethod === "Email" ? emails : [],
        phoneNumber: receiptMethod === "Text" ? phoneNumber : "",
        transferVia: receiptMethod,
      };
      const apiPath = isCashOrCheck
        ? `${process.env.REACT_APP_TC_PMS}/api/PatientPayment/GenerateAndSendPaymentReceipt`
        : `${process.env.REACT_APP_TC_PMS}/api/PatientPayment/SendPaymentReceipt`;
      api
        .post(apiPath, payload)
        .then((resp) => {
          toast.success(resp.data.responseMessage);
          onClose();
        })
        .catch(ErrorHandlingMessage)
        .finally(() => setLoader(false));
    }
  };

  return (
    <ReactPortal wrapperId="SendReceiptPopup">
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
        <div className="w-full max-w-md bg-white rounded-lg shadow-xl">
          <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
            <h3 className="text-lg font-semibold text-slate-800">
              Send Receipt
            </h3>
            <button
              onClick={onClose}
              className="transition-colors text-slate-400 hover:text-slate-600"
            >
              <LuX className="w-5 h-5" />
            </button>
          </div>

          <div className="p-6">
            <div className="space-y-4">
              <div>
                <label className="block mb-2 text-sm font-medium text-slate-700">
                  Send Via
                </label>
                <div className="flex gap-3">
                  <button
                    onClick={() => setReceiptMethod("Email")}
                    className={`flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-lg border-2 transition-colors ${
                      receiptMethod === "Email"
                        ? "border-primary bg-primary/10 text-primary"
                        : "border-slate-200 bg-white text-slate-600 hover:border-slate-300"
                    }`}
                  >
                    <LuMail className="w-5 h-5" />
                    <span className="font-medium">Email</span>
                  </button>
                  <button
                    onClick={() => setReceiptMethod("Text")}
                    className={`flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-lg border-2 transition-colors ${
                      receiptMethod === "Text"
                        ? "border-primary bg-primary/10 text-primary"
                        : "border-slate-200 bg-white text-slate-600 hover:border-slate-300"
                    }`}
                  >
                    <ChatIcon className="w-5 h-5" />
                    <span className="font-medium">Text</span>
                  </button>
                </div>
              </div>

              {receiptMethod === "Email" ? (
                <div>
                  <label
                    htmlFor="email"
                    className="block mb-2 text-sm font-medium text-slate-700"
                  >
                    Email Address
                  </label>

                  <MultiEmailInput
                    emails={emails}
                    setEmails={setEmails}
                    // setMyValidationModel={setMyValidationModel}
                  />
                  {myValidationModel.emailToError}
                </div>
              ) : (
                <div>
                  <label
                    htmlFor="phone"
                    className="block mb-2 text-sm font-medium text-slate-700"
                  >
                    Phone Number
                  </label>

                  <CustomInput
                    id="phone"
                    value={MaskPhoneNumber(phoneNumber)}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    placeholder="Enter phone number"
                  />
                  {myValidationModel.phoneNumberError}
                </div>
              )}

              <div className="p-4 border rounded-lg bg-slate-50 border-slate-200">
                <div className="mb-2 text-xs font-medium text-slate-600">
                  Receipt Details
                </div>
                <div className="space-y-1 text-sm">
                  <div className="flex justify-between">
                    <span className="text-slate-600">Payment #:</span>
                    <span className="font-medium text-slate-800">
                      {paymentMainId}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-slate-600">Amount:</span>
                    <span className="font-medium text-slate-800">
                      {NumberConversion(paidAmount)}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-slate-600">Date:</span>
                    <span className="font-medium text-slate-800">
                      {" "}
                      {FormatMomentDate(receivedDate)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex gap-3 px-6 py-4 border-t border-slate-200">
            <CustomButtonNew
              label="Cancel"
              variant="outline"
              onClick={onClose}
              className="flex-1"
            />
            <CustomButtonNew
              label="Send Receipt"
              onClick={handleSendReceipt}
              disabled={loader}
              loading={loader}
              className="flex-1"
            />
          </div>
        </div>
      </div>
    </ReactPortal>
  );
};

export default SendReceiptPopup;
